module.exports = __webpack_public_path__ + "img/40_38_049_530.e982b6bc.jpg";